import { Container, Group } from '@mantine/core';

export const Footer = () => {
  return (
    <Container fluid mt="lg" mb="lg">
      <Container size="lg">
        <Group justify="space-between"></Group>
      </Container>
    </Container>
  );
};
